import React, { useState } from "react";
import { Container, Form, Button, Alert } from "react-bootstrap";

const ResetPassword = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setMessage("Passwords do not match!");
            return;
        }
        // Here, you would send the new password to your backend API.
        setMessage("Your password has been successfully reset!");
    };

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <div className="w-50 p-4 border rounded shadow bg-white">
                <h3 className="mb-3 text-center">Reset Password</h3>
                {message && <Alert variant={message.includes("success") ? "success" : "danger"}>{message}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>New Password</Form.Label>
                        <input
                            type="password"
                            placeholder="Enter new password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Confirm Password</Form.Label>
                        <input
                            className="form-control"

                            type="password"
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit" className="w-100">
                        Reset Password
                    </Button>
                </Form>
            </div>
        </Container>
    );
};

export default ResetPassword;
